import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';

@Component({
  selector: 'app-select-applicationtype-model',
  standalone: true,
  imports: [ CommonModule,
    FormsModule,
    ReactiveFormsModule,DropdownModule],
    //schemas:[CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './select-applicationtype-model.component.html',
  styleUrl: './select-applicationtype-model.component.scss'
})
export class SelectApplicationtypeModelComponent implements OnInit {
  @Input() public Content: any;
  ApplicationTypeList: any = [];
  applicationTypeForm: UntypedFormGroup;
  constructor(
    public modalRef: NgbActiveModal,
    private commonservice: CommonService,
    private datashare:IstDataShareService
  ) { }

  ngOnInit() {
    this.applicationTypeForm = new UntypedFormGroup({
      APPLICATION_TYPE_ID:  new UntypedFormControl(""),
    });
    this.getApplicationtypes();
  }

  showConfirm(): void {
    let appTypeID = this.applicationTypeForm.controls["APPLICATION_TYPE_ID"].value;
    if(!appTypeID){
        this.commonservice.ValidationBanner("To proceed further, select application type");
      }
      else{
        this.datashare.setApplication_Type_ID(this.applicationTypeForm.controls["APPLICATION_TYPE_ID"].value);
        this.modalRef.close(this.applicationTypeForm.controls["APPLICATION_TYPE_ID"].value);
      }
    
  }
  CancelClcik(): void {
    this.modalRef.dismiss();
  }
  getApplicationtypes() {
    let submodule = "-1";
    if (this.Content.ModuleID == "4") {
      submodule = this.Content.SubModuleID;
    }
    this.commonservice.getAllApplicationTypes(this.Content.ModuleID, submodule).subscribe((result) => {
      if (result) {
        this.ApplicationTypeList = result;
      }
    });
  }
}
